import type { ModalBaseProps } from "@/stores/application";

export enum LOCALE_STORAGE_KEYS {
  THEME = "THEME",
  TABLE_CONFIG = "TABLE_CONFIG",
  NUMBER_CONFIG = "NUMBER_CONFIG",
  GENERAL_OPTION = "GENERAL_OPTION",
}

export const LOCAL_STORAGE_KEYS_TO_REMOVE_WHEN_LOGOUT = [];

export enum TYPE_EXPORT {
  XLSX = "xlsx",
  PDF = "pdf",
}

export enum DATE_FORMAT_ENUM {
  DATE = "DD-MM-YYYY",
  MONTH = "MM-YYYY",
  DATE_TIME = "DD-MM-YYYY HH:mm:ss",
}

export const MAX_IMAGE_SIZE_MB = 5;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;
export const ALLOWED_IMAGE_TYPES = ["image/gif", "image/svg+xml", "image/jpeg", "image/jpg", "image/png", "image/webp"];

export const MAX_DOCUMENT_SIZE_MB = 5;
export const MAX_DOCUMENT_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;
export const ALLOWED_DOCUMENT_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "application/pdf",
  "text/plain",
  "application/xml", // .xml
  "text/xml", // .xml
  "application/json",
];

export const NATION_VIET_NAM_ID = "72426019-c27a-4da6-85fe-dca46c4a86bb";

export const PROVINCE_OPTIONS = [
  { label: "Thành phố Cần Thơ", value: "e8d5d2ad-38d3-4752-a9b1-11eeca8a4947" },
  { label: "Thành phố Đà Nẵng", value: "ec6fe0bf-f183-4eab-818d-827369391a29" },
  { label: "Thành phố Hà Nội", value: "c37dee18-cfdc-4e23-a499-d2279dd52fea" },
  { label: "Thành phố Hải Phòng", value: "7d483be1-7bdb-40c5-9117-016cbf3b4df5" },
  { label: "Thành phố Hồ Chí Minh", value: "e865b9fb-1184-4d68-b438-9fa72912b5ff" },
  { label: "Tỉnh An Giang", value: "ea746cb1-3ceb-452c-b9c4-c196b943c920" },
  { label: "Tỉnh Bà Rịa - Vũng Tàu", value: "db563fc2-e5a8-417c-ad37-e266f9b957b8" },
  { label: "Tỉnh Bắc Giang", value: "0bab5630-65c7-410a-bc52-2cc90bb7d75f" },
  { label: "Tỉnh Bắc Kạn", value: "cc191616-124b-47ec-89da-e7f833773538" },
  { label: "Tỉnh Bạc Liêu", value: "1c68c3a5-eb74-4f00-99a8-de7076f515bb" },
  { label: "Tỉnh Bắc Ninh", value: "7757914b-f029-49f1-9e1f-25a27c451da6" },
  { label: "Tỉnh Bến Tre", value: "aedaf705-b132-4f62-ba49-bbce383ec274" },
  { label: "Tỉnh Bình Dương", value: "338f99e5-a3f9-4631-a97d-82267973bba4" },
  { label: "Tỉnh Bình Định", value: "8ce32d3e-3f4a-4aa4-9ed8-c11f042c526f" },
  { label: "Tỉnh Bình Phước", value: "73a25a4a-712c-4335-ad25-aa8f0964ff3c" },
  { label: "Tỉnh Bình Thuận", value: "c0e49762-4073-4f9e-9a71-3bf140548027" },
  { label: "Tỉnh Cà Mau", value: "ba36b614-9761-4059-b0c5-f767269c56ff" },
  { label: "Tỉnh Cao Bằng", value: "4699975f-7205-4895-844a-ff6e534e59ae" },
  { label: "Tỉnh Đắk Lắk", value: "553cba48-6206-4b20-b697-7cf57e2d0665" },
  { label: "Tỉnh Đắk Nông", value: "1543c8f1-5a3b-4c7c-8d20-dbec428aa954" },
  { label: "Tỉnh Điện Biên", value: "c8f4ffb6-a936-477c-856c-00dac71127e2" },
  { label: "Tỉnh Đồng Nai", value: "647439b3-1cd9-4b14-bd06-ab719ea9560a" },
  { label: "Tỉnh Đồng Tháp", value: "345c226b-0c2f-4e38-ad1e-c13ebe449793" },
  { label: "Tỉnh Gia Lai", value: "0b70f46a-7adf-43ef-bfb2-d23c60af17dd" },
  { label: "Tỉnh Hà Giang", value: "ad1ce040-4949-4a61-b1e7-ca87346467fd" },
  { label: "Tỉnh Hà Nam", value: "72cadb4d-6fad-43d6-acad-dac745fb631d" },
  { label: "Tỉnh Hà Tĩnh", value: "c63d9741-9ead-46f8-ae0f-cf4788c3abe2" },
  { label: "Tỉnh Hải Dương", value: "091a6895-4646-4d80-9931-b15d576329b9" },
  { label: "Tỉnh Hậu Giang", value: "65520d8f-2b85-461f-b7c8-bdefade5c5de" },
  { label: "Tỉnh Hoà Bình", value: "f8d0c545-8509-4855-ad45-4af734c4233b" },
  { label: "Tỉnh Hưng Yên", value: "a3e6578b-5406-42fd-8928-92e7033961da" },
  { label: "Tỉnh Khánh Hòa", value: "ebc71497-3ed0-4b7b-93cb-109d10d8fe57" },
  { label: "Tỉnh Kiên Giang", value: "eacb9a6b-5eaa-43a4-b5af-8413d7691623" },
  { label: "Tỉnh Kon Tum", value: "6645ada2-5f68-4699-9649-97f665531fa8" },
  { label: "Tỉnh Lai Châu", value: "fdd84757-ff61-4401-93e7-a5321346b3f7" },
  { label: "Tỉnh Lâm Đồng", value: "9248585d-7c07-457e-892e-317ead0405f5" },
  { label: "Tỉnh Lạng Sơn", value: "6752073d-9c54-4e70-8cb3-982181dc7fa4" },
  { label: "Tỉnh Lào Cai", value: "e8e7ce10-4e70-479d-b2a5-c8ca5d58ddcf" },
  { label: "Tỉnh Long An", value: "1d7eb5dc-783b-46d9-9720-9fae20e32945" },
  { label: "Tỉnh Nam Định", value: "3afe1edf-179a-46b2-8924-68d4a64e8944" },
  { label: "Tỉnh Nghệ An", value: "84f326ce-a875-43da-a58b-f773aec48fab" },
  { label: "Tỉnh Ninh Bình", value: "91a4971f-3291-4b9e-b829-3108ee935b1a" },
  { label: "Tỉnh Ninh Thuận", value: "fb5004c6-4df1-476c-81d8-a41b39a2b9a8" },
  { label: "Tỉnh Phú Thọ", value: "95b17304-1ad8-427d-a2da-e1d27c7ad942" },
  { label: "Tỉnh Phú Yên", value: "7bc941b5-3bc9-4ea1-ba00-69c5fea10c4c" },
  { label: "Tỉnh Quảng Bình", value: "7c7d64ec-08d1-4980-9c91-7414ad2ca93f" },
  { label: "Tỉnh Quảng Nam", value: "915ca51c-5c35-4f90-b411-07e121119962" },
  { label: "Tỉnh Quảng Ngãi", value: "0abdd10b-a8ac-4bf9-b5f9-86eeceb32b05" },
  { label: "Tỉnh Quảng Ninh", value: "3f24f1d6-fe1c-44d5-a2b5-3fc51fe7cddb" },
  { label: "Tỉnh Quảng Trị", value: "1ca1ddb3-3ea6-4d19-bc37-5993de457d6d" },
  { label: "Tỉnh Sóc Trăng", value: "4c3c337e-7ae2-47c6-bda7-a9e043b43e74" },
  { label: "Tỉnh Sơn La", value: "45ef18ec-96d9-486e-bc85-271c2dcc394a" },
  { label: "Tỉnh Tây Ninh", value: "916e2819-fb18-4aba-b820-7f856389cb28" },
  { label: "Tỉnh Thái Bình", value: "c0498e7d-ce8e-4d81-b5ba-9d78a4247096" },
  { label: "Tỉnh Thái Nguyên", value: "c10788c9-ee15-42e0-a030-972cdeaa69fc" },
  { label: "Tỉnh Thanh Hóa", value: "f52d2081-03f7-4f9a-a372-f267456a4fce" },
  { label: "Tỉnh Thừa Thiên Huế", value: "cb7c0460-1101-4a6c-8495-37f116debbc3" },
  { label: "Tỉnh Tiền Giang", value: "08bd51cd-576e-4747-9466-f68e640fd2d4" },
  { label: "Tỉnh Trà Vinh", value: "4c83953a-7f2d-4aad-814f-b8e337e6db60" },
  { label: "Tỉnh Tuyên Quang", value: "f6bf2c42-4071-41b3-98de-abe525630514" },
  { label: "Tỉnh Vĩnh Long", value: "08c9b1e1-6418-4a2f-a203-437f16da1168" },
  { label: "Tỉnh Vĩnh Phúc", value: "b8c94cb8-197b-409c-8b47-8a6071013521" },
  { label: "Tỉnh Yên Bái", value: "10c05355-4d07-4ffb-a268-91d53ce7a9c5" },
];

export interface FilterModalProps extends ModalBaseProps {
  initialValues: any;
}

enum INPUT_NUMBER_SYMBOL_ENUM {
  Parentheses = 0,
  NegativePrefix = 1,
  NegativeSuffix = 2,
}

const SYMBOL_DESCRIPTIONS = new Map<INPUT_NUMBER_SYMBOL_ENUM, string>([
  [INPUT_NUMBER_SYMBOL_ENUM.Parentheses, "(n)"],
  [INPUT_NUMBER_SYMBOL_ENUM.NegativePrefix, "-n"],
  [INPUT_NUMBER_SYMBOL_ENUM.NegativeSuffix, "n-"],
]);

export function getInputNumberSymbol(symbol: any) {
  return SYMBOL_DESCRIPTIONS.get(symbol) || SYMBOL_DESCRIPTIONS.get(INPUT_NUMBER_SYMBOL_ENUM.Parentheses) || "";
}

enum INPUT_NUMBER_COLOR_ENUM {
  Red = 0,
  Black = 1,
  Orange = 2,
  Blue = 3,
  Purple = 4,
}

const COLOR_DESCRIPTIONS = new Map<INPUT_NUMBER_COLOR_ENUM, string>([
  [INPUT_NUMBER_COLOR_ENUM.Red, "red"],
  [INPUT_NUMBER_COLOR_ENUM.Black, "black"],
  [INPUT_NUMBER_COLOR_ENUM.Orange, "orange"],
  [INPUT_NUMBER_COLOR_ENUM.Blue, "blue"],
  [INPUT_NUMBER_COLOR_ENUM.Purple, "purple"],
]);

export function getInputNumberColor(color: any) {
  return COLOR_DESCRIPTIONS.get(color) || COLOR_DESCRIPTIONS.get(INPUT_NUMBER_COLOR_ENUM.Red) || "";
}

export enum TYPE_REFERENCE_ENUM {
  FIXED_ASSET_INCREMENT = 1,
  FIXED_ASSET_DECREMENT = 2,
  FIXED_ASSET_REVALUATION = 3,
  FIXED_ASSET_TRANSFER = 4,
  FIXED_ASSET_DEPRECIATION_SCHEDULE = 5,
  FINANCE_LEASE_ASSET_TRANSFER_TO_OWNER = 6,
  INVENTORY_INCREMENT = 7,
  INVENTORY_TRANSFER = 8,
  INVENTORY_DECREMENT = 9,
  INVENTORY_ALLOCATION = 10,
  INVENTORY_ADJUSTMENT = 11,
  CASH_RECEIPT = 12,
  CASH_PAYMENT = 13,
  BANK_RECEIPT = 14,
  PAYMENT_ORDER = 15,
  CASH_CHECK = 16,
  TRANSFER_CHECK = 17,
  INTERNAL_TRANSFER = 18,
  REPOSITORY_RECEIPT = 19,
  REPOSITORY_ISSUE = 20,
  REPOSITORY_TRANSFER = 21,
  PRODUCTION_ORDER = 22,
  ASSEMBLY_ORDER = 23,
  DISASSEMBLY_ORDER = 24,
  PURCHASE_ORDER = 25,
  PURCHASE_STOCK_IN = 26,
  PURCHASE_NO_STOCK = 27,
  SERVICE_PURCHASE = 28,
  PURCHASE_RETURN_STOCK_IN = 29,
  PURCHASE_RETURN_NO_STOCK = 30,
  PURCHASE_DISCOUNT = 31,
  PURCHASE_INVOICE_RECEIVED = 32,
  QUOTATION = 33,
  SALES_ORDER = 34,
  SALES = 35,
  SALES_RETURN = 36,
  SALES_DISCOUNT = 37,
  SALES_INVOICE = 38,
  OTHER_BUSINESS_DOCUMENTS = 39,
  TAX_DEDUCTION = 40,
  PROFIT_LOSS_TRANSFER = 41,
  EXCHANGE_RATE_ADJUSTMENT = 42,
  DEBT_OFFSET = 43,
  ADVANCE_SETTLEMENT = 44,
  EXCHANGE_RATE_DISCREPANCY = 45,
  VAT_ADJUSTMENT = 46,
  PREPAID_EXPENSE_ALLOCATION = 47,
  EXPENSE_TRANSFER = 48,
  PROJECT_ACCEPTANCE = 49,
  SALES_ORDER_ACCEPTANCE = 50,
  CONTRACT_ACCEPTANCE = 51,
  EXPENSE_ALLOCATION_PROJECT_ORDER_CONTRACT_UNIT = 52,
  EXPENSE_ALLOCATION_BRANCH = 53,
  SALARY_EXPENSE_ACCOUNTING = 54,
  PURCHASE_CONTRACT = 55,
  SALES_CONTRACT = 56,
  INTERNAL_REPOSITORY_TRANSFER = 57,
  INTERNAL_TRANSFER_WITH_TRANSPORT = 58,
  CONSIGNMENT_FOR_AGENCY = 59,
  DEPOSIT_RECEIPT = 60,
  DEPOSIT_PAYMENT = 61,
  OTHER = 0,
}

export const REFERENCE_TYPE_OPTIONS = {
  [TYPE_REFERENCE_ENUM.FIXED_ASSET_INCREMENT]: "Ghi tăng tài sản cố định",
  [TYPE_REFERENCE_ENUM.FIXED_ASSET_DECREMENT]: "Ghi giảm tài sản cố định",
  [TYPE_REFERENCE_ENUM.FIXED_ASSET_REVALUATION]: "Đánh giá lại tài sản cố định",
  [TYPE_REFERENCE_ENUM.FIXED_ASSET_TRANSFER]: "Điều chuyển tài sản cố định",
  [TYPE_REFERENCE_ENUM.FIXED_ASSET_DEPRECIATION_SCHEDULE]: "Bảng tính khấu hao tài sản cố định",
  [TYPE_REFERENCE_ENUM.FINANCE_LEASE_ASSET_TRANSFER_TO_OWNER]: "Chuyển tài sản thuê tài chính sang tài sản chủ sở hữu",
  [TYPE_REFERENCE_ENUM.INVENTORY_INCREMENT]: "Ghi tăng CCDC",
  [TYPE_REFERENCE_ENUM.INVENTORY_TRANSFER]: "Điều chuyển CCDC",
  [TYPE_REFERENCE_ENUM.INVENTORY_DECREMENT]: "Ghi giảm CCDC",
  [TYPE_REFERENCE_ENUM.INVENTORY_ALLOCATION]: "Phân bổ CCDC",
  [TYPE_REFERENCE_ENUM.INVENTORY_ADJUSTMENT]: "Điều chỉnh công cụ dụng cụ",
  [TYPE_REFERENCE_ENUM.CASH_RECEIPT]: "Thu tiền mặt",
  [TYPE_REFERENCE_ENUM.CASH_PAYMENT]: "Chi tiền mặt",
  [TYPE_REFERENCE_ENUM.BANK_RECEIPT]: "Thu tiền gửi",
  [TYPE_REFERENCE_ENUM.PAYMENT_ORDER]: "Ủy nhiệm chi",
  [TYPE_REFERENCE_ENUM.CASH_CHECK]: "Séc tiền mặt",
  [TYPE_REFERENCE_ENUM.TRANSFER_CHECK]: "Séc chuyển khoản",
  [TYPE_REFERENCE_ENUM.INTERNAL_TRANSFER]: "Chuyển tiền nội bộ",
  [TYPE_REFERENCE_ENUM.REPOSITORY_RECEIPT]: "Nhập kho",
  [TYPE_REFERENCE_ENUM.REPOSITORY_ISSUE]: "Xuất kho",
  [TYPE_REFERENCE_ENUM.REPOSITORY_TRANSFER]: "Chuyển kho",
  [TYPE_REFERENCE_ENUM.PRODUCTION_ORDER]: "Lệnh sản xuất",
  [TYPE_REFERENCE_ENUM.ASSEMBLY_ORDER]: "Lệnh lắp ráp",
  [TYPE_REFERENCE_ENUM.DISASSEMBLY_ORDER]: "Lệnh tháo gỡ",
  [TYPE_REFERENCE_ENUM.PURCHASE_ORDER]: "Đơn mua hàng",
  [TYPE_REFERENCE_ENUM.PURCHASE_STOCK_IN]: "Mua hàng nhập kho",
  [TYPE_REFERENCE_ENUM.PURCHASE_NO_STOCK]: "Mua hàng không qua kho",
  [TYPE_REFERENCE_ENUM.SERVICE_PURCHASE]: "Chứng từ mua dịch vụ",
  [TYPE_REFERENCE_ENUM.PURCHASE_RETURN_STOCK_IN]: "Hàng mua trả lại - Qua kho",
  [TYPE_REFERENCE_ENUM.PURCHASE_RETURN_NO_STOCK]: "Hàng mua trả lại - Không qua kho",
  [TYPE_REFERENCE_ENUM.PURCHASE_DISCOUNT]: "Hàng mua giảm giá",
  [TYPE_REFERENCE_ENUM.PURCHASE_INVOICE_RECEIVED]: "Nhận hóa đơn mua hàng hóa",
  [TYPE_REFERENCE_ENUM.QUOTATION]: "Báo giá",
  [TYPE_REFERENCE_ENUM.SALES_ORDER]: "Đơn đặt hàng",
  [TYPE_REFERENCE_ENUM.SALES]: "Bán hàng",
  [TYPE_REFERENCE_ENUM.SALES_RETURN]: "Hàng bán bị trả lại",
  [TYPE_REFERENCE_ENUM.SALES_DISCOUNT]: "Giảm giá hàng bán",
  [TYPE_REFERENCE_ENUM.SALES_INVOICE]: "Hóa đơn bán hàng",
  [TYPE_REFERENCE_ENUM.OTHER_BUSINESS_DOCUMENTS]: "Chứng từ nghiệp vụ khác",
  [TYPE_REFERENCE_ENUM.TAX_DEDUCTION]: "Khấu trừ thuế",
  [TYPE_REFERENCE_ENUM.PROFIT_LOSS_TRANSFER]: "Kết chuyển lãi, lỗ",
  [TYPE_REFERENCE_ENUM.EXCHANGE_RATE_ADJUSTMENT]: "Chứng từ xử lý chênh lệch tỷ giá",
  [TYPE_REFERENCE_ENUM.DEBT_OFFSET]: "Chứng từ bù trừ công nợ",
  [TYPE_REFERENCE_ENUM.ADVANCE_SETTLEMENT]: "Chứng từ quyết toán tạm ứng",
  [TYPE_REFERENCE_ENUM.EXCHANGE_RATE_DISCREPANCY]: "Xử lý chênh lệch tỷ giá",
  [TYPE_REFERENCE_ENUM.VAT_ADJUSTMENT]: "Điều chỉnh thuế GTGT",
  [TYPE_REFERENCE_ENUM.PREPAID_EXPENSE_ALLOCATION]: "Phân bổ chi phí trả trước",
  [TYPE_REFERENCE_ENUM.EXPENSE_TRANSFER]: "Kết chuyển chi phí",
  [TYPE_REFERENCE_ENUM.PROJECT_ACCEPTANCE]: "Nghiệm thu công trình/vụ việc",
  [TYPE_REFERENCE_ENUM.SALES_ORDER_ACCEPTANCE]: "Nghiệm thu đơn hàng",
  [TYPE_REFERENCE_ENUM.CONTRACT_ACCEPTANCE]: "Nghiệm thu hợp đồng",
  [TYPE_REFERENCE_ENUM.EXPENSE_ALLOCATION_PROJECT_ORDER_CONTRACT_UNIT]:
    "Phân bổ chi phí BH, QLDN, chi phí khác cho công trình, đơn hàng, hợp đồng, đơn vị",
  [TYPE_REFERENCE_ENUM.EXPENSE_ALLOCATION_BRANCH]: "Phân bổ chi phí cho chi nhánh",
  [TYPE_REFERENCE_ENUM.SALARY_EXPENSE_ACCOUNTING]: "Hạch toán chi phí lương",
  [TYPE_REFERENCE_ENUM.PURCHASE_CONTRACT]: "Hợp đồng mua",
  [TYPE_REFERENCE_ENUM.SALES_CONTRACT]: "Hợp đồng bán",
  [TYPE_REFERENCE_ENUM.INTERNAL_REPOSITORY_TRANSFER]: "Xuất chuyển kho nội bộ",
  [TYPE_REFERENCE_ENUM.INTERNAL_TRANSFER_WITH_TRANSPORT]: "Xuất kho kiêm vận chuyển nội bộ",
  [TYPE_REFERENCE_ENUM.CONSIGNMENT_FOR_AGENCY]: "Xuất kho gửi bán đại lý",
  [TYPE_REFERENCE_ENUM.OTHER]: "Khác",
};

// Declare the enum with numeric values
export const DateOptionsEnum = {
  TODAY: 0,
  THIS_WEEK: 1,
  START_OF_WEEK_TO_NOW: 2,
  THIS_MONTH: 3,
  START_OF_MONTH_TO_NOW: 4,
  THIS_QUARTER: 5,
  START_OF_QUARTER_TO_NOW: 6,
  THIS_YEAR: 7,
  START_OF_YEAR_TO_NOW: 8,
  FIRST_HALF_YEAR: 9,
  LAST_HALF_YEAR: 10,
  JANUARY: 11,
  FEBRUARY: 12,
  MARCH: 13,
  APRIL: 14,
  MAY: 15,
  JUNE: 16,
  JULY: 17,
  AUGUST: 18,
  SEPTEMBER: 19,
  OCTOBER: 20,
  NOVEMBER: 21,
  DECEMBER: 22,
  QUARTER_1: 23,
  QUARTER_2: 24,
  QUARTER_3: 25,
  QUARTER_4: 26,
  YESTERDAY: 27,
  LAST_WEEK: 28,
  LAST_MONTH: 29,
  LAST_QUARTER: 30,
  LAST_YEAR: 31,
  TOMORROW: 32,
  NEXT_WEEK: 33,
  NEXT_MONTH: 34,
  NEXT_QUARTER: 35,
  NEXT_YEAR: 36,
  CUSTOM: 37,
};

export const dateOptionsArray = [
  { value: DateOptionsEnum.TODAY, label: "Hôm nay" },
  { value: DateOptionsEnum.THIS_WEEK, label: "Tuần này" },
  { value: DateOptionsEnum.START_OF_WEEK_TO_NOW, label: "Đầu tuần tới hiện tại" },
  { value: DateOptionsEnum.THIS_MONTH, label: "Tháng này" },
  { value: DateOptionsEnum.START_OF_MONTH_TO_NOW, label: "Đầu tháng đến hiện tại" },
  { value: DateOptionsEnum.THIS_QUARTER, label: "Quý này" },
  { value: DateOptionsEnum.START_OF_QUARTER_TO_NOW, label: "Đầu quý đến hiện tại" },
  { value: DateOptionsEnum.THIS_YEAR, label: "Năm nay" },
  { value: DateOptionsEnum.START_OF_YEAR_TO_NOW, label: "Đầu năm đến hiện tại" },
  { value: DateOptionsEnum.FIRST_HALF_YEAR, label: "Sáu tháng đầu năm" },
  { value: DateOptionsEnum.LAST_HALF_YEAR, label: "Sáu tháng cuối năm" },
  { value: DateOptionsEnum.JANUARY, label: "Tháng 1" },
  { value: DateOptionsEnum.FEBRUARY, label: "Tháng 2" },
  { value: DateOptionsEnum.MARCH, label: "Tháng 3" },
  { value: DateOptionsEnum.APRIL, label: "Tháng 4" },
  { value: DateOptionsEnum.MAY, label: "Tháng 5" },
  { value: DateOptionsEnum.JUNE, label: "Tháng 6" },
  { value: DateOptionsEnum.JULY, label: "Tháng 7" },
  { value: DateOptionsEnum.AUGUST, label: "Tháng 8" },
  { value: DateOptionsEnum.SEPTEMBER, label: "Tháng 9" },
  { value: DateOptionsEnum.OCTOBER, label: "Tháng 10" },
  { value: DateOptionsEnum.NOVEMBER, label: "Tháng 11" },
  { value: DateOptionsEnum.DECEMBER, label: "Tháng 12" },
  { value: DateOptionsEnum.QUARTER_1, label: "Quý 1" },
  { value: DateOptionsEnum.QUARTER_2, label: "Quý 2" },
  { value: DateOptionsEnum.QUARTER_3, label: "Quý 3" },
  { value: DateOptionsEnum.QUARTER_4, label: "Quý 4" },
  { value: DateOptionsEnum.YESTERDAY, label: "Hôm qua" },
  { value: DateOptionsEnum.LAST_WEEK, label: "Tuần trước" },
  { value: DateOptionsEnum.LAST_MONTH, label: "Tháng trước" },
  { value: DateOptionsEnum.LAST_QUARTER, label: "Quý trước" },
  { value: DateOptionsEnum.LAST_YEAR, label: "Năm trước" },
  { value: DateOptionsEnum.TOMORROW, label: "Ngày mai" },
  { value: DateOptionsEnum.NEXT_WEEK, label: "Tuần sau" },
  { value: DateOptionsEnum.NEXT_MONTH, label: "Tháng sau" },
  { value: DateOptionsEnum.NEXT_QUARTER, label: "Quý sau" },
  { value: DateOptionsEnum.NEXT_YEAR, label: "Năm sau" },
  { value: DateOptionsEnum.CUSTOM, label: "Tùy chọn" },
];
